package com.tovtalk.domain.usecase.auth

import com.tovtalk.domain.entity.LoginMethod
import com.tovtalk.domain.entity.DomainResult
import com.tovtalk.domain.entity.User
import com.tovtalk.domain.repository.UserRepository

/**
 * Register Use Case
 */
class RegisterUseCase(
    private val userRepository: UserRepository
) {
    suspend operator fun invoke(
        fullname: String,
        email: String,
        password: String,
        loginMethod: LoginMethod
    ): DomainResult<User> {
        // Validation
        if (fullname.isBlank()) {
            return DomainResult.Error("Full name cannot be empty")
        }
        
        if (email.isBlank()) {
            return DomainResult.Error("Email cannot be empty")
        }
        
        if (!isValidEmail(email)) {
            return DomainResult.Error("Invalid email format")
        }
        
        if (password.length < 6) {
            return DomainResult.Error("Password must be at least 6 characters")
        }
        
        // Register
        return userRepository.register(fullname, email, password, loginMethod)
    }
    
    private fun isValidEmail(email: String): Boolean {
        val emailRegex = "^[A-Za-z0-9+_.-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,}$".toRegex()
        return email.matches(emailRegex)
    }
}
